module.exports = __webpack_public_path__ + "components/flag/static/square/gn-60e52c94829742eae0693716c4c68343.svg";